import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation, Link } from "react-router-dom";
import { Menu, Button, Image, Icon } from "semantic-ui-react";
import { getImage } from "Actions/storageActions";
import { update } from "Actions/localActions";
import fellaImage from "../../assets/images/fella-full-logo.png";
import User from "FirebaseObj/user";

function NavBar({
  fixed,
  secondary,
  inverted,
  showLogo,
  showActions,
  leftItems,
}) {
  const [activeTab, setActiveTab] = useState(
    leftItems && Object.keys(leftItems)[0]
  );
  
  const profile = useSelector((state) => state.auth.profile);
  const storage = useSelector((state) => state.storage);
  
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const currentUser = User.fromJson(profile);

  useEffect(() => {
    if (storage && currentUser && currentUser.photoSmall && !storage[currentUser.photoSmall]) {
      dispatch(getImage(currentUser.photoSmall));
    }
  }, [profile, storage, dispatch, currentUser]);

  const handleUpdateLocal = (data) => dispatch(update(data));

  return (
    <Menu
      className="navigation-bar"
      fixed={fixed ? "top" : null}
      inverted={inverted}
      pointing={!fixed}
      secondary={secondary}
      size="small"
    >
      {location.pathname === "/home" ? (
        <Menu.Item
          onClick={() => {
            handleUpdateLocal({ showSideBar: true });
          }}
        >
          <Icon size="large" name="sidebar" />
        </Menu.Item>
      ) : null}
      <div className="navigation-header">
        {showLogo ? (
          <Link to="/">
            <Image size="small" src={fellaImage} />
          </Link>
        ) : (
          <div style={{ width: 72 }} />
        )}
      </div>
      {leftItems
        ? Object.keys(leftItems).map((tab) => {
            return (
              <Menu.Item
                key={tab}
                as="div"
                active={activeTab === tab}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </Menu.Item>
            );
          })
        : null}
      <Menu.Item position="right">
        {!currentUser.uid ? (
          <div>
            <Button inverted={!fixed} onClick={() => history.push("/login")}>
              Log in
            </Button>
            {showActions ? (
              <Button as="a" primary style={{ marginLeft: "0.5em" }}>
                Activate
              </Button>
            ) : null}
          </div>
        ) : (
          <div>
            {currentUser.uid &&
            currentUser.isLeader() &&
            location.pathname !== "/home" ? (
              <Button
                as="a"
                primary
                style={{ marginRight: "1em" }}
                onClick={() => history.push("/home")}
              >
                Go to Dashboard
              </Button>
            ) : null}
            <Image
              src={
                storage[currentUser.photoSmall] ||
                "https://react.semantic-ui.com/images/wireframe/square-image.png"
              }
              avatar
            />
          </div>
        )}
      </Menu.Item>
    </Menu>
  );
}

NavBar.propTypes = {
  fixed: PropTypes.bool,
  inverted: PropTypes.bool,
  secondary: PropTypes.bool,
  showLogo: PropTypes.bool,
  showActions: PropTypes.bool,
  leftItems: PropTypes.object,
};

export default NavBar;

